'use client';
import { useCarInsuranceContext } from 'car-insurance/context';
import { useRouter } from 'next/navigation';
import { PropsWithChildren } from 'react';
import { CTAButton } from './CTAButton';

export const BackButton: React.FC<PropsWithChildren> = ({ children }) => {
  const router = useRouter();
  const { form } = useCarInsuranceContext();
  return (
    <CTAButton
      onClick={() => {
        form.setIsChanged(true);
        router.back();
      }}
      className="flex flex-row justify-center items-center w-full md:w-69 bg-orange-800 hover:bg-orange-900 text-white text-base md:text-lg lg:text-xl font-semibold font-sans rounded-lg md:rounded-xl cursor-pointer sm:h-9 md:h-10 h-11"
    >
      {children}
    </CTAButton>
  );
};
